import { API, graphqlOperation} from "aws-amplify"
import { sortedCodesByType, } from '../graphql/queries'
/*
import { analizeTypeGroupByCategory, } from '../graphql/queries'
import { analizeTypeByGroup, } from '../graphql/queries'
import { sortedStandardValueByOffice, } from '../graphql/queries'
import { sortedAnalizeSetByType, } from '../graphql/queries'
import { sortedAnalizeItemByType, } from '../graphql/queries'
import { analizeItemByCompany, } from '../graphql/queries'
*/
import { officeByCompany, } from '../graphql/queries'
//import { officeByKey, } from '../graphql/queries'
//import { oilTypeByCategory, } from '../graphql/queries'

export default {
    data: () => ({
    }),
    methods: {
        fetchAllOfficeByCompany: async function(companyID) {
            let result = await API.graphql(graphqlOperation(officeByCompany, {CompanyID: companyID, limit: 999}))
            let items = result.data.officeByCompany.items
            let nextToken = result.data.officeByCompany.nextToken
            while (nextToken) {
                let next = await API.graphql(graphqlOperation(officeByCompany, {CompanyID: companyID, limit: 999, nextToken: nextToken}))
                items = items.concat(next.data.officeByCompany.items)
                nextToken = next.data.officeByCompany.nextToken
            }
            return items
        },
        initAnalizeInfoCore: async function () {
            console.log("■■ initAnalizeInfoCore start", this.$store.state.initializedAnalize)
            if(!this.$store.state.initializedAnalize) {
                console.log("■■ initAnalizeInfoCore do")
                //----------------------------------------
                // 単位（使用量に関する単位）を初期化
                //----------------------------------------
                let useUnit = await API.graphql(graphqlOperation(sortedCodesByType, {CodeType: "useUnit"}))
                let _useUnit = useUnit.data.sortedCodesByType.items
                _useUnit.sort(function(a,b){
                    if(a.Order < b.Order) return -1;
                    if(a.Order > b.Order) return 1;
                    return 0;
                });
                this.$store.commit('setUseUnits',_useUnit )
                console.log('_useUnit:', _useUnit)
                //----------------------------------------
                // 単位（液量に関する単位）を初期化
                //----------------------------------------
                let liquidUnit = await API.graphql(graphqlOperation(sortedCodesByType, {CodeType: "liquidUnit"}))
                let _liquidUnit = liquidUnit.data.sortedCodesByType.items
                _liquidUnit.sort(function(a,b){
                    if(a.Order < b.Order) return -1;
                    if(a.Order > b.Order) return 1;
                    return 0;
                });

                this.$store.commit('setLiquidUnits',_liquidUnit )
                console.log('_liquidUnit:', _liquidUnit)
/*
                //----------------------------------------
                // オイルタイプカテゴリを初期化
                //  潤滑油,燃料...
                //----------------------------------------
                let _oilCategory = await API.graphql(graphqlOperation(sortedCodesByType, {CodeType: "oilCategory" + this.$store.state.operatingCompany.AnalizeTypeGroup}))
                let oilCategoryList = _oilCategory.data.sortedCodesByType.items
                this.$store.commit('setOilTypeCategoryList',oilCategoryList )
                //----------------------------------------
                // オイルタイプカテゴリ別のオイルタイプを初期化
                //  潤滑油=第四石油類、動植物油類  燃料=特殊引火物、第一石油類、第二石油類...のような感じのデータリスト
                //----------------------------------------
                let oilTypeList=[]
                for (var oilCategory of oilCategoryList) {
                    let _oilTypeList = await API.graphql(graphqlOperation(oilTypeByCategory, {OilCategory: oilCategory.Value}))
                    let oilTypeListItem = {OilTypeCategory: oilCategory.Value, OilType: _oilTypeList.data.oilTypeByCategory.items}
                    oilTypeList.push(oilTypeListItem)
                }
                this.$store.commit('setOilTypeList',oilTypeList )
//                console.log("■■オイルタイプ:",oilTypeList)
*/


                //----------------------------------------
                // 事業所一覧を初期化
                // 管理者権限がある場合、選択中の企業の全事業所
                // 管理者権限がない場合、選択中の事業ののみ
                //----------------------------------------
                if(this.$store.state.isAdmin) {
//                    console.log("★★is Admin",this.$store.state.isAdmin)
                    let officeList = await this.fetchAllOfficeByCompany(this.$store.state.operatingOffice.CompanyID)

                    // 企業名、事業所名の変更は担当者（Employee）連携時に反映されない
                    // 各マスタの名称で上書きする
                    // 得意先の請求先事業所コードを設定する（事業所はもっていないため
                    for (const office of officeList) {
                        office["CompanyName"] = this.$store.state.operatingCompany.Name
                        office["PaymentOfficeID"] = this.$store.state.operatingCompany.PaymentOfficeID
                    }
                    //----------------------------------------
                    // ログインユーザと選択中の事業所（企業）が違う場合はログインユーザの企業の事業所の一覧も取得
                    if(this.$store.state.operatingOffice.CompanyID != this.$store.state.myoffice.CompanyID) {
                        let myofficeList = await this.fetchAllOfficeByCompany(this.$store.state.myoffice.CompanyID)

                        // 企業名、事業所名の変更は担当者（Employee）連携時に反映されない
                        // 各マスタの名称で上書きする
                        for (const office of myofficeList) {
                            office["CompanyName"] = this.$store.state.mycompany.Name
                            office["PaymentOfficeID"] = this.$store.state.operatingCompany.PaymentOfficeID
                        }
                        officeList = officeList.concat(myofficeList)
                    }
                    this.$store.commit('setOfficeList', officeList )
                }else {
                    let officeList = await this.fetchAllOfficeByCompany(this.$store.state.operatingOffice.CompanyID)
                    // 企業名、事業所名の変更は担当者（Employee）連携時に反映されない
                    // 各マスタの名称で上書きする
                    for (const office of officeList) {
                        office["CompanyName"] = this.$store.state.operatingCompany.Name
                        office["PaymentOfficeID"] = this.$store.state.operatingCompany.PaymentOfficeID
                    }
                    this.$store.commit('setOfficeList', officeList )
                }
/*
                //----------------------------------------
                // 選択中の事業所（企業）の依頼タイプを取得（一般/JET/JX）
                //----------------------------------------
                let analizeTypeGroup = await API.graphql(graphqlOperation(analizeTypeGroupByCategory, {AnalizeTypeCategory: this.$store.state.operatingCompany.AnalizeTypeGroup}))
                this.$store.commit('setAnalizeTypeGroupList',analizeTypeGroup.data.analizeTypeGroupByCategory.items )

                //----------------------------------------
                // 依頼タイプ毎の各種情報を取得
                //  1. 分析方法（社定法、公定法）
                //    1.1 分析区分（潤滑油、燃料 etx）
                //      1.1.1 分析セット
                //      1.1.2 分析項目
                //      1.1.3 分析規格
                //----------------------------------------
                let analizeTypeGroupList = analizeTypeGroup.data.analizeTypeGroupByCategory.items
                let analizeTypeList = []
                let analizeTypeListArray = []
                //----------------------------------------
                // 分析区分（潤滑油、燃料 etx）               
                for (var group of analizeTypeGroupList) {
                    let analizeType = await API.graphql(graphqlOperation(analizeTypeByGroup, {AnalizeTypeGroup: group.Value}))
                    let analizeTypeListItem = {AnalizeTypeGroup: group.Value, AnalizeTypes: analizeType.data.analizeTypeByGroup.items}
                    analizeTypeList.push(analizeTypeListItem)
                    for(var a of analizeType.data.analizeTypeByGroup.items) {
                        analizeTypeListArray.push(a)
                    }
                }
                this.$store.commit('setAnalizeTypeList',analizeTypeList )
*/
                // 得意先ホルダの有無（契約得意先か）
                let contractCompany = false
/*
                //----------------------------------------
                // 分析規格              
                let _standardValueAllType = await API.graphql(graphqlOperation(sortedStandardValueByOffice, {OfficeID: this.$store.state.operatingOffice.OfficeID, items: "AnalizeType, Text, Value, StandardValue"}))
                let standardValueAllType = _standardValueAllType.data.sortedStandardValueByOffice.items

                //----------------------------------------
                // 得意先（企業）別分析項目(全部取得)
                let analizeItem4Com = await API.graphql(graphqlOperation(analizeItemByCompany, {CompanyID: this.$store.state.operatingOffice.CompanyID} ))
                let _analizeItem4Com = analizeItem4Com.data.analizeItemByCompany.items

                //----------------------------------------
                // 分析区分毎の分析セットと分析項目              
                let analizeSetList = []
                let analizeItemList = []
                let standardValueList = []
                for (var type of analizeTypeListArray) {
                    //----------------------------------------
                    // 分析セット
                    //  共通 Company=0000000000 
                    //  企業別特別セット Company=企業コード
                    let setFilter = {
                        or: [
                        { Company: {eq: "0000000000"} },
                        { Company: {eq: this.$store.state.operatingOffice.CompanyID} },
                        ]
                    }
                    let analizeSet = await API.graphql(graphqlOperation(sortedAnalizeSetByType, {AnalizeType: type.Value, filter:setFilter, limit:300}))
                    let _analizeSet = analizeSet.data.sortedAnalizeSetByType.items
                    let analizeSetListItem = {AnalizeType: type.Value, AnalizeSets: _analizeSet}
                    analizeSetList.push(analizeSetListItem)

                    //----------------------------------------
                    // 分析項目
                    let analizeItem = await API.graphql(graphqlOperation(sortedAnalizeItemByType, {AnalizeType: type.Value, limit:300} ))
                    let _analizeItem = analizeItem.data.sortedAnalizeItemByType.items
                    for (var item4com of _analizeItem4Com) {
                        // 得意先（企業）別分析項目で上書き
                        var aaa = _analizeItem.filter(item => item.Value  == item4com.Value)
                        if(aaa[0]) {
                            aaa[0].RegularPrice = aaa[0].Price
                            aaa[0].Price = item4com.Price
                            if(item4com.CustomText) {
                                aaa[0].Text = item4com.CustomText
                            }
                            contractCompany = true
                        }
                    }
                    let analizeItemListItem = {AnalizeType: type.Value, AnalizeItems: _analizeItem}
                    analizeItemList.push(analizeItemListItem)
            
                    //----------------------------------------
                    // 分析区分毎の分析規格のみ
                    let standardValue = standardValueAllType.filter(item => item.AnalizeType == type.Value)
                    let standardValueListItem = {AnalizeType: type.Value, standardValues: standardValue}
                    standardValueList.push(standardValueListItem)
                }
                this.$store.commit('setAnalizeSetList', analizeSetList )
                this.$store.commit('setAnalizeItemList', analizeItemList )
                this.$store.commit('setStandardValueList', standardValueList )
*/
            
                this.$store.commit('setContractCompany', contractCompany )
                this.$store.commit('setInitializedAnalize', true )
            }
            console.log("■■ end initAnalizeInfoCore")
        },
    }
};